import {
  Component,
  ElementRef,
  EventEmitter,
  forwardRef,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import {
  ControlValueAccessor,
  FormBuilder,
  NG_VALUE_ACCESSOR,
} from '@angular/forms';
import { Subject } from 'rxjs';

@Component({
  selector: 'md-select',
  templateUrl: './md-select.component.html',
  styleUrls: ['./md-select.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => MdSelectComponent),
      multi: true,
    },
  ],
})
export class MdSelectComponent
  implements OnInit, OnDestroy, ControlValueAccessor
{
  @Input() color:
    | 'primary'
    | 'primary-stroked'
    | 'primary-text'
    | 'primary-opacity'
    | 'accent'
    | 'accent-stroked'
    | 'accent-text'
    | 'accent-opacity'
    | 'warn'
    | 'warn-stroked'
    | 'warn-text'
    | 'warn-opacity';
  @Input() type = '';
  @Input() placeholder = '';
  @Input() debounce = 500;
  @Input() data = [];
  @Input() label = '';

  @Output() inputEmit: EventEmitter<string> = new EventEmitter<string>();

  constructor(private fb: FormBuilder, private el: ElementRef) {}

  selectedItem: any;
  value: any;

  disabled: boolean;
  destroy$ = new Subject();

  ngOnInit(): void {
    console.log(this.data);
  }
  ngOnDestroy(): void {
    this.destroy$.next(null);
    this.destroy$.complete();
  }

  onChange(_: any) {}
  onTouched = () => {};

  registerOnChange(fn) {
    this.onChange = fn;
  }
  registerOnTouched(fn) {
    this.onTouched = fn;
  }
  writeValue(value: any) {
    this.value = value;
  }
  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }
}
